import { render, staticRenderFns } from "./anumberscomponent.vue?vue&type=template&id=c4782dec&"
import script from "./anumberscomponent.vue?vue&type=script&lang=ts&"
export * from "./anumberscomponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports